import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../hooks/useAuthContext'
import { useAmplitude } from '../../hooks/useAmplitude'
import { AmplitudeEvents } from '../../types/amplitude'
import type { GetStartedClickedProperties } from '../../types/amplitude'

export function Header() {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuthContext()
  const { track } = useAmplitude()

  const handleGetStartedClick = () => {
    // Track the event
    const eventProperties: GetStartedClickedProperties = {
      url: window.location.href,
      description: 'simple-landing-page-test',
      location: 'header',
      isAuthenticated,
      timestamp: new Date().toISOString(),
    }
    track(AmplitudeEvents.GET_STARTED_CLICKED, eventProperties)

    // Navigate
    if (isAuthenticated) {
      navigate('/dashboard')
    } else {
      navigate('/auth')
    }
  }

  return (
    <header className="header">
      <nav className="nav-container">
        <div className="nav-left">
          <div className="logo-container">
            <img src="/gist-g-logo.png" alt="Gist Logo" className="logo" />
            <div className="company-name">
              <span>Ask</span>
              <span>Anything</span>
            </div>
          </div>
        </div>
        <div className="nav-right">
          <button className="get-started-btn" onClick={handleGetStartedClick}>
            Get Started
          </button>
        </div>
      </nav>
    </header>
  )
}
